import type { FunctionComponent, PropsWithChildren, ReactElement, ReactNode } from 'react';
import { useState } from 'react';

import { Accordion } from '../../accordion/Accordion';
import { Icon } from '../../icons/icon';
import { Icons } from '../../icons/iconNames';
import { Text } from '../../text/Text';

import styles from './HelpAccordion.module.css';

interface HelpChapterProps extends PropsWithChildren {
  /** for storybook testing */
  chapterName?: string;
  isOpen?: boolean;
  title: ReactNode;
}

export const HelpChapter: FunctionComponent<HelpChapterProps> = ({
  children,
  title,
  isOpen = false,
  chapterName,
}): ReactElement | null => {
  const [isAccordionOpen, setAccordionOpen] = useState<boolean>(isOpen);

  if (!children) return null;

  return (
    <Accordion
      sectionName={chapterName}
      header={
        <div className={styles.help__chapterButton}>
          {title}
          <Icon icon={isAccordionOpen ? Icons.ChevronUp : Icons.ChevronDown} />
        </div>
      }
      isOpen={isAccordionOpen}
      onToggle={() => setAccordionOpen((isOpen) => !isOpen)}
    >
      <Text className={styles.help__chapterContent}>{children}</Text>
    </Accordion>
  );
};
